import { render, staticRenderFns } from "./ModalConfirmBilling.vue?vue&type=template&id=628750aa&"
import script from "./ModalConfirmBilling.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports